import { useEffect } from 'react';
import { profileApi } from '@/api/auth';
import { getToken } from '@/lib/auth-storage';
import { resetChatwootUser, syncChatwootUser } from '@/lib/chatwoot';

let syncGeneration = 0;

function syncIdentityFromAuth(): void {
  const generation = ++syncGeneration;

  if (!getToken()) {
    resetChatwootUser();
    return;
  }

  const tokenAtStart = getToken();
  profileApi()
    .then((res) => {
      if (generation !== syncGeneration || !getToken() || getToken() !== tokenAtStart) {
        if (!getToken()) {
          resetChatwootUser();
        }
        return;
      }
      if (res.code === 0 && res.data?.userId != null && res.data.userName && res.data.chatwootIdentifierHash) {
        syncChatwootUser(
          String(res.data.userId),
          res.data.userName,
          res.data.chatwootIdentifierHash,
        );
      }
    })
    .catch(() => {
      /* ignore */
    });
}

/** 已登录时同步 Chatwoot 用户身份；未登录时 reset */
export default function ChatwootBootstrap() {
  useEffect(() => {
    syncIdentityFromAuth();
    window.addEventListener('mh-auth-changed', syncIdentityFromAuth);
    return () => {
      window.removeEventListener('mh-auth-changed', syncIdentityFromAuth);
    };
  }, []);

  return null;
}
